const isString = require('lodash/isString');
const filter = require('lodash/filter');
const get = require('lodash/get');
const first = require('lodash/first');
const currencies = require('./currencies').currencies;
const uoms = {
  ft: { code: 'ft', conversionFactors: { m: 0.3048, ft: 1 } },
  m: { code: 'm', conversionFactors: { m: 1, ft: 3.28084 } }
};

const locales = {
  'en-US': {
    code: 'en-US',
    language: 'en',
    country: 'US',
    lengthUom: uoms.ft,
    currency: currencies.USD,
    orderSeparator: ',',
    decimalSeparator: '.'
  },
  'en-CA': {
    code: 'en-CA',
    language: 'en',
    country: 'CA',
    lengthUom: uoms.m,
    currency: currencies.CAD,
    orderSeparator: ',',
    decimalSeparator: '.'
  },
  'en-AU': {
    code: 'en-AU',
    language: 'en',
    country: 'AU',
    lengthUom: uoms.m,
    currency: currencies.AUD,
    orderSeparator: ',',
    decimalSeparator: '.'
  },
  'en-GB': {
    code: 'en-GB',
    language: 'en',
    country: 'GB',
    lengthUom: uoms.ft,
    currency: currencies.GBP,
    orderSeparator: ',',
    decimalSeparator: '.'
  },
  'es-ES': {
    code: 'es-ES',
    language: 'es',
    country: 'ES',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: '.',
    decimalSeparator: ','
  },
  'de-DE': {
    code: 'de-DE',
    language: 'de',
    country: 'DE',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: '.',
    decimalSeparator: ','
  },
  'fr-FR': {
    code: 'fr-FR',
    language: 'fr',
    country: 'FR',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: ' ',
    decimalSeparator: ','
  },
  'it-IT': {
    code: 'it-IT',
    language: 'it',
    country: 'IT',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: '.',
    decimalSeparator: ','
  },
  'nl-NL': {
    code: 'nl-NL',
    language: 'nl',
    country: 'NL',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: '.',
    decimalSeparator: ','
  },
  'nb-NO': {
    code: 'nb-NO',
    language: 'nb',
    country: 'NO',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: ' ',
    decimalSeparator: ','
  },
  'ru-RU': {
    code: 'ru-RU',
    language: 'ru',
    country: 'RU',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: ' ',
    decimalSeparator: ','
  },
  'sv-SE': {
    code: 'sv-SE',
    language: 'sv',
    country: 'SV',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: ' ',
    decimalSeparator: ','
  },
  'fi-FL': {
    code: 'fi-FL',
    language: 'fi',
    country: 'FL',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: ' ',
    decimalSeparator: ','
  },
  'da-DK': {
    code: 'da-DK',
    language: 'da',
    country: 'DK',
    lengthUom: uoms.m,
    currency: currencies.EUR,
    orderSeparator: '.',
    decimalSeparator: ','
  }
};

module.exports.locales = locales;
module.exports.uoms = uoms;

module.exports.findByCountry = (country) => {

  if (!isString(country)) {
    return null;
  }

  return first(filter(locales, (l) => {
    return l.country.toUpperCase() === country.toUpperCase();
  })) || null;
};

module.exports.getLocaleProperty = (lang, key) => {
  const locale = locales[lang] || locales['en-US'];
  return get(locale, key, null);
};
